import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISagaCb } from '@typings/requestPayloads'

export interface IEditTablePayload extends ISagaCb {
    tableId: string
    data: any
}

export interface IEditTableState {
    status: string
    statusItems: string[]
    data: any
    errors: any
}

const initialState: IEditTableState = {
    status: STATUS.IDLE,
    statusItems: [],
    data: null,
    errors: null
}

const editTable = createSlice({
    name: 'table/edit',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IEditTablePayload>) {
            state.status = STATUS.RUNNING
            state.statusItems = [...state.statusItems, action.payload.tableId]
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload.response
            state.statusItems = state.statusItems.filter(item => item !== action.payload.tableId)
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload.error
            state.statusItems = state.statusItems.filter(item => item !== action.payload.tableId)
        }
    }
})

export const editTableActions = editTable.actions
export default editTable.reducer
